import { get } from 'lodash';
import { ERROR_DIMENSION_MAP } from '@src/utils/dimension/errorCodeHelper';
import { DIMENSION_TAG } from '../dimension/createGroupBy';

const GEO_ISP = 'GEO_ISP';
const GEO_ASN = 'GEO_ASN';

export default function createFilterRule(dimension, name, value) {
  let dimensionField = null;
  let dimensionKey = null;
  // dimensionField might be changed when ASN is used to resolve ISP
  // track the originalField for creating filters
  // filters using the same originalField should be OR together
  let originalField = null;

  if (dimension) {
    dimensionField = dimension.field;
    originalField = dimensionField;
    if (dimensionField === DIMENSION_TAG) {
      dimensionKey = dimension.groupBy;
    }
    if (dimensionField === GEO_ISP && !value.startsWith('isp:')) {
      dimensionField = GEO_ASN;
    }
  }
  return {
    field: dimensionField,
    key: dimensionKey,
    op: 'eq',
    value,
    display: name,
    originalField,
  };
}

export function createFilterRuleFromDimensionTable(allDimensionsList, dimension, row) {
  if (dimension in ERROR_DIMENSION_MAP) {
    const display = get(row, 'name[0]', '');
    const value = get(row, 'value[0]', '');
    return {
      field: DIMENSION_TAG,
      key: dimension,
      op: 'eq',
      value,
      display,
    };
  }

  const dimensionList = allDimensionsList;
  const dimensionObj = dimensionList.find((d) => d.groupBy === dimension);
  const rule = createFilterRule(dimensionObj, get(row, 'name[0]', ''), get(row, 'value[0]', ''));

  return rule;
}
